import React from "react";
import "./Credits.css";

const Credits = () => {
  return (
    <a
      id="credits"
      style={{ textTransform: "uppercase", color: "white" }}
      href="https://epranka.com"
      target="_blank"
      rel="noopener noreferrer"
      title="Edvinas Pranka | Senior Developer"
    >
      <span>epranka.com</span>
    </a>
  );
};

export default Credits;
